import { useSelector } from "react-redux";

import { useGetXpRewards } from "services/xpService/hooks";

import { useShowExtendedRewardsFeatureFlag } from "seneca-common/features/levels/rewardsFeatureFlag";
import { premiumHasAccessToExamQuestions } from "seneca-common/features/subscriptions/features/subscription/selectors";
import { subscriptionsFetchFinished } from "seneca-common/features/subscriptions/state";
import { fetchSubscriptionsIfNotFetched } from "seneca-common/features/subscriptions/state/service";
import { useDispatchOnMount } from "seneca-common/utils/hooks/dispatch";
import useSelectorOnCondition from "seneca-common/utils/hooks/selectors/useSelectorOnCondition";

import { useRemainingExamQuestions } from "./useRemainingExamQuestions";

export default function useHasAccessToExamQuestions() {
  useDispatchOnMount(fetchSubscriptionsIfNotFetched);
  const subscriptionsFetched = useSelector(subscriptionsFetchFinished);

  const { data: xpRewards, isLoading: isXpRewardsLoading } = useGetXpRewards();

  const {
    remainingQuestionsCount: remainingExamQuestionsTrial,
    isLoading: isTrialLoadingEQ
  } = useRemainingExamQuestions();

  const hasExamQuestions = !!useSelectorOnCondition(
    subscriptionsFetched,
    premiumHasAccessToExamQuestions
  );

  const isExtendedRewardsReleased = useShowExtendedRewardsFeatureFlag();

  const remainingExamQuestions = hasExamQuestions
    ? Infinity
    : !isExtendedRewardsReleased
      ? remainingExamQuestionsTrial
      : xpRewards?.examQuestion ?? 0;

  const isLoading =
    !subscriptionsFetched || isTrialLoadingEQ || isXpRewardsLoading;

  return {
    isLoading,
    hasUnlimitedQuestions: remainingExamQuestions === Infinity,
    hasAccessToExamQuestions: remainingExamQuestions > 0,
    remainingQuestionsCount: remainingExamQuestions
  };
}
